// No-op adapter — observabilité désactivée, zéro effet de bord
export class NullAdapter {
  init() {}
  captureException() {}
  captureMessage() {}
  setUser() {}
  addBreadcrumb() {}
}
